import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "main-footer",
  id: "main-footer",
  style: {"padding":"5px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pull-right hidden-xs" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Version"),
  /*#__PURE__*/_createTextVNode("1.0.0")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "© 2023-2026 华标版权所有", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, _hoisted_4))
}